import React, { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { makeId } from '../../../utilities/idComponent';

const SVG_IMAGES = [
  'account-payable',
  'account-receivable',
  'accurate',
  'bank-indonesia',
  'bca-virtual-account',
  'biller-api',
  'blocked-card',
  'blocked-card2',
  'bulk-disbursement-illustration',
  'bulk-disbursement',
  'cash-deposit-illustration',
  'cash-deposit',
  'cash-withdrawal-illustration',
  'CC_BACKGROUND_BLUE',
  'CC_BACKGROUND_GRAY',
  'CC_BACKGROUND_GREEN',
  'CC_BACKGROUND_ORANGE',
  'CC_BACKGROUND_PINK',
  'CC_BACKGROUND_PURPLE',
  'cdm-illustration',
  'cdm-illustration2',
  'claim-fund',
  'corporate-card',
  'disabled-payment-method',
  'disabled-payment-method2',
  'disbursement-api',
  'e-wallet-api',
  'e-wallet-qris',
  'empty-information',
  'empty-invoice',
  'empty-learning',
  'empty-new-feature',
  'empty-notifications',
  'empty-notifications2',
  'empty-promo',
  'emptyState_failed',
  'emptyState_notificationMaintenanceBank',
  'emptyState_scheduleMaintenanceBank',
  'emptyState_failed',
  'illustration-balance',
  'illustration-block-va',
  'illustration-bulk-request',
  'illustration-calendar',
  'illustration-camera',
  'illustration-cash-delivery-denomination',
  'illustration-cash-delivery-payment-method',
  'illustration-change-bank-account',
  'illustration-expired-invoice',
  'illustration-feedback',
  'illustration-help',
  'illustration-help2',
  'illustration-id-card',
  'illustration-no-image',
  'illustration_notInternet',
  'illustration_notHaveAccess',
  'illustration-paymentSuccess',
  'illustration-scan-id-card',
  'illustration-search2',
  'illustration-selfie-with-id-card',
  'illustration-selfie-photo',
  'illustration-user-deactivated',
  'illustration-card-locked',
  'illustration-download',
  'illustration-requestApproval',
  'inquiry-api',
  'international-transfer',
  'item-not-found-black',
  'item-not-found',
  'jurnal',
  'link-not-found',
  'logo-oy-default',
  'mini-virtual-card-gold',
  'mini-virtual-card-grey',
  'mini-virtual-card',
  'multi-account-management',
  'no-categories',
  'no-transaction-found-new',
  'no-transaction-found',
  'no-transaction-found2',
  'payment-link-illustration',
  'payment-link',
  'payment-routing',
  'reimbursement-e-catalogue-modal',
  'separator',
  'transactions-data-api',
  'upgrade-account',
  'vcc-promo-banner-main',
  'vcc-promo-banner-secondary',
  'virtual-account',
  'xero',
] as const;

type ImageName = (typeof SVG_IMAGES)[number];

const BASE_URL =
  'https://oy-static-assets.s3.ap-southeast-1.amazonaws.com/pay/images';

const PNG_IMAGES = [
  'account-payable',
  'account-receivable',
  'AccountReceivable_InvoiceTemplateColorfull',
  'AccountReceivable_InvoiceTemplateModern',
  'AccountReceivable_InvoiceTemplateRetail',
  'AccountReceivable_InvoiceTemplateSpreadsheet',
  'AccountReceivable_InvoiceTemplateStandard',
  'AccountReceivable_InvoiceTemplateStandard',
  'accurate',
  'banner-cross-sell',
  'bca-virtual-account',
  'biller-api',
  'bulk-disburse-thumbnail',
  'bulk-disbursement',
  'cash-deposit',
  'CC_BACKGROUND_PHYSICAL',
  'cdm-thumbnail',
  'claim-fund',
  'corporate-card',
  'cross-sell-banner-modal',
  'disbursement-api',
  'e-wallet-api',
  'e-wallet-qris',
  'illustration-search',
  'illustration-user-deactivated',
  'inquiry-api',
  'international-transfer',
  'jurnal',
  'mini_vcc_blue',
  'mini_vcc_gray',
  'mini_vcc_green',
  'mini_vcc_orange',
  'mini_vcc_pink',
  'mini_vcc_purple',
  'multi-account-management',
  'ovo_guide1',
  'ovo_guide2',
  'payment-link-thumbnail',
  'payment-link',
  'payment-routing',
  'physicalCard_Dummy_Active',
  'physicalCard_learnMore',
  'physicalCard_learnMore2',
  'reference-guideline-1',
  'reference-guideline-2',
  'reference-guideline-3',
  'reimbursement-e-catalogue-modal',
  'sent',
  'success',
  'testimony_aruna',
  'testimony_bareksa',
  'testimony_credimart',
  'testimony_vokraf',
  'transactions-data-api',
  'usecase_mam',
  'usecase-ap',
  'usecase-ar',
  'usecase-biller-api',
  'usecase-bulk-disbursement',
  'usecase-cash-deposit-api',
  'usecase-cash-deposit',
  'usecase-cash-withdraw-api',
  'usecase-cash-withdrawal',
  'usecase-cdm',
  'usecase-claim-fund',
  'usecase-corporate-card',
  'usecase-customer-data',
  'usecase-disbursement-api',
  'usecase-ewalletA-api',
  'usecase-inquiry-api',
  'usecase-international-transfer',
  'usecase-payment-link',
  'usecase-payment-routing',
  'usecase-va',
  'usecase-vendor-data',
  'vcc_banner_card',
  'vcc_banner_info',
  'VCC_promo_banner_desktop',
  'VCC_promo_banner_mobile',
  'vcc-promo-banner-main',
  'vcc-promo-banner-secondary',
  'video-ap',
  'video-ar',
  'video-biller-api',
  'video-bulk-disbursement',
  'video-cash-deposit-api',
  'video-cash-deposit',
  'video-cash-withdraw-api',
  'video-cash-withdraw',
  'video-cdm',
  'video-claim-fund',
  'video-corporate-card',
  'video-customer-data',
  'video-disbursement-api',
  'video-ewallet-api',
  'video-inquiry-api',
  'video-international-transfer',
  'video-mam',
  'video-payment-link',
  'video-payment-routing',
  'video-va',
  'video-vendor-data',
  'virtual-account',
  'virtualCard_Acquisition',
  'virtualCard_Dummy_Active',
  'virtualCard_Dummy_Active2',
  'virtualCard_Dummy_Register',
  'xero',

] as const;

type PngImageName = (typeof PNG_IMAGES)[number];

const isPng = (value: string): value is PngImageName => {
  return PNG_IMAGES.includes(value as PngImageName);
};

const WEBP_IMAGES = [
  'banner_customer_service',
  'banner_pending_approval',
  'emptyState_accountPayable',
  'emptyState_accountReceivable',
  'emptyState_analytics',
  'emptyState_apiBiller',
  'emptyState_apiCashDeposit',
  'emptyState_apiCashWithdrawal',
  'emptyState_apiDisbursement',
  'emptyState_apiEwallet',
  'emptyState_apiInquiry',
  'emptyState_bulkDisbursement',
  'emptyState_cashDelivery',
  'emptyState_cashDeposit',
  'emptyState_cashWithdrawal',
  'emptyState_cdm',
  'emptyState_claimFund',
  'emptyState_corporateCard',
  'emptyState_customerData',
  'emptyState_home',
  'emptyState_internationalTransfer',
  'emptyState_KYB',
  'emptyState_mem',
  'emptyState_paymentLink',
  'emptyState_paymentRouting',
  'emptyState_paymentSuccess',
  'emptyState_va',
  'emptyState_vendorManagement',
  'virtual-account-2',
] as const;

type WebPImageName = (typeof WEBP_IMAGES)[number];

const isWebP = (value: string): value is WebPImageName => {
  return WEBP_IMAGES.includes(value as WebPImageName);
};

const getExtension = (name: PngImageName | ImageName | WebPImageName) => {
  if (isWebP(name)) {
    return 'webp';
  } else if (isPng(name)) {
    return 'png';
  }

  return 'svg';
};

export type ImageNameType = ImageName | WebPImageName | PngImageName;
export const IMAGE_NAMES = [...SVG_IMAGES, ...PNG_IMAGES, ...WEBP_IMAGES];

// Helper function for using Images as a CSS Background Image (i.e. background-image: url(...))
export const imageUrl = (name: PngImageName | WebPImageName | ImageName) => {
  return `url('${BASE_URL}/${name}.${getExtension(name)}')`;
};

type ImageProps = {
  /**
   * To add new image, you need to ask infra team to upload your new image.
   * And don't forget to add the name to {@link ImageName}
   * @BASE_URL https://oy-static-assets.s3.ap-southeast-1.amazonaws.com/pay/images
   */
  name: ImageNameType;
} & DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const getImageUrl = (name: ImageNameType) =>
  `${BASE_URL}/${name}.${getExtension(name)}`;

function Image({ name, ...props }: ImageProps) {
  return (
    <img
      id={makeId('img', name)}
      alt={name}
      src={getImageUrl(name)}
      {...props}
    />
  );
}

export default Image;
